import React from 'react'
import TypoCss from "./typography.module.scss";



function Description({description}) {
  return (
    <div className={`${TypoCss.card_description} ${TypoCss.medium_text_size}`}>
      {description}
    </div>
  );
}

export default Description